export const SEARCHABLE_ROLE = {
  educator: 'educator',
  publisher: 'publisher',
  student: 'student'
}
